
export let consts = {
  accounts: {
    system: {
      id: "c3lzdGVt",
    }
  }
}